import CardOrderModal from './views/main.c.js';
export default CardOrderModal;
